//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      payload: {
        limit: 10,
        offset: 0,
      },
      // 表格
      loading: false,
      list: [],
      docName: '',
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      segmentContent: '',
      segmentSerialNum: '',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      // this.getElementList
      console.log('%c Line:154 🍷 this.getElementList', 'color:#4fff4B', this.getElementList);
      const jurisdictionArray = ['documentsSegments_agent_switch'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      console.log('%c Line:167 🍷 testjurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
    datasetId() {
      return this.$route.query.dataset_id;
    },
  },
  async created() {
    this.getDocInfo();
    this.getList();
  },
  methods: {
    async getDocInfo() {
      try {
        const { document } = await this.$request({
          url: this.$api.getAgentDocument,
          data: {
            id: this.$route.query.document_id,
          },
        });
        this.docName = document.name;
      } catch (e) {
        console.error(e);
        this.$message.error('获取文档数据失败');
      }
    },
    async getList(showLoading = true) {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { segments, total_count: total } = await this.$request({
          url: this.$api.listAgentDocumentSegments,
          data: {
            document_id: this.$route.query.document_id,
            ...this.payload,
          },
          showLoading,
        });
        this.list = segments;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    showContent(row) {
      this.dialogVisible = true;
      this.segmentContent = row.content;
      this.segmentSerialNum = row.serial_num;
    },
    goBack() {
      this.$router.history.go(-1);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async onChangeEnable(row, enabled) {
      try {
        await this.$request({
          url: this.$api.updateAgentDocumentSegment,
          data: {
            id: row.id,
            segment: {
              enabled,
            },
          },
          showLoading: false,
        });
        this.getList(false);
      } catch (err) {
        this.$message.error(enabled === true ? '启用失败' : '停用失败');
        console.log(err);
        this.getList(false);
      }
    },
  },
};
